import React from 'react';
import styled from 'styled-components';
import { Points } from '@styles';
import { Colors } from 'planoplan-ui-kit/core/colors';

export const SlideContent = ({ slide = {} }) => {
  return (
    <View>
      <Photo>
        <Img
          src={slide.image}
          srcset={(slide.webp_image, slide.image)}
          alt={slide.alt}
          decoding="async"
          loading="lazy"
        />
      </Photo>
      <Content>
        <Text>{slide.text}</Text>
        <Bottom>
          <PhotoMobile>
            <Img src={slide.mobile_img} alt={slide.alt} decoding="async" loading="lazy" />
          </PhotoMobile>
          <Name>{slide.name}</Name>
          <Caption>{slide.caption}</Caption>
          <Link target="_blank" href={slide.link}>
            {slide.text_link}
          </Link>
        </Bottom>
      </Content>
    </View>
  );
};

const View = styled.div`
  width: 100%;
  height: 100%;
  border-radius: 20px;
  overflow: hidden;
  background-color: ${Colors.beige_100};
  display: flex;
  color: ${Colors.main_black};
`;
const Photo = styled.div`
  width: 225px;
  min-height: 300px;
  flex-shrink: 0;
  display: none;

  @media ${Points.tablet_landscape} {
    display: block;
  }

  @media ${Points.laptop_wide} {
    width: 300px;
    min-height: 400px;
  }
`;
const Img = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;
const Content = styled.div`
  display: flex;
  flex-direction: column;
  padding: 30px;
`;
const Text = styled.div`
  flex-grow: 1;
  font-size: 18px;
  line-height: 1.1;
  margin-bottom: 30px;

  @media ${Points.tablet_landscape} {
    margin-bottom: 0;
  }

  @media ${Points.laptop_wide} {
    font-size: 24px;
  }
`;
const Bottom = styled.div``;
const PhotoMobile = styled.div`
  width: 50px;
  height: 50px;
  border-radius: 50%;
  overflow: hidden;
  margin-bottom: 10px;

  @media ${Points.tablet_landscape} {
    display: none;
  }
`;
const Name = styled.div`
  font-size: 16px;
  line-height: 1.3;

  @media ${Points.laptop_wide} {
    font-size: 18px;
  }
`;
const Caption = styled.div`
  font-size: 12px;
  line-height: 1.1;

  @media ${Points.laptop_wide} {
    font-size: 14px;
  }
`;
const Link = styled.a`
  margin-top: 20px;
  font-size: 14px;
  line-height: 1.1;
  color: ${Colors.main_blue};
  text-decoration: none;
  display: inline-block;

  @media ${Points.laptop_wide} {
    font-size: 16px;
  }

  &:hover {
    color: ${Colors.blue_500};
  }
`;
